<template>
	<div class="d-flex a-center j-center">
		<div class="content-box">
			<div class="d-flex a-center" style="margin-bottom: 1.875rem;">
				<div style="white-space: nowrap;" class="left-trial">所属业务员：</div>
				<div class="right-trial">{{trialInfo.supply_name}}</div>
			</div>
			<div class="d-flex a-center" style="margin-bottom: 1.875rem;">
				<div style="white-space: nowrap;" class="left-trial">提交申请时间：</div>
				<div class="right-trial">{{trialInfo.add_time}}</div>
			</div>
			<div class="d-flex a-center" style="margin-bottom: 1.875rem;">
				<div style="white-space: nowrap;" class="left-trial">机构/单位名称：</div>
				<div class="right-trial">{{trialInfo.supply_bu_name}}</div>
			</div>
			<div class="d-flex a-center" style="margin-bottom: 1.875rem;">
				<div style="white-space: nowrap;" class="left-trial">地址：</div>
				<div class="right-trial">{{trialInfo.address_region}}{{trialInfo.address}}</div>
			</div>
			<div class="d-flex a-center" style="margin-bottom: 1.875rem;">
				<div style="white-space: nowrap;" class="left-trial">联系人：</div>
				<div class="right-trial">{{trialInfo.supply_name}}</div>
			</div>
			<div class="d-flex a-center" style="margin-bottom: 1.875rem;">
				<div style="white-space: nowrap;" class="left-trial">联系电话：</div>
				<div class="right-trial">{{trialInfo.supply_mobile}}</div>
			</div>
			<div class="d-flex a-center" style="margin-bottom: 1.875rem;">
				<div style="white-space: nowrap;" class="left-trial">申请试用时间：</div>
				<div class="right-trial">{{trialInfo.try_time}}</div>
			</div>
			<div class="d-flex a-center" style="margin-bottom: 1.875rem;" v-if="trialInfo.problem && trialInfo.problem.length!=0">
				<div style="white-space: nowrap;" class="left-trial">{{trialInfo.cat_title}}：</div>
				<div class="d-flex a-center flex-wrap" style="width: 350px;">
					<div v-for="(item,index) in trialInfo.problem" :key="index"
					style="height: 24px;width: 70px;border-radius: 12px;background-color: #EEEEEE;color: #888888;font-size: 12px;margin-right: 1rem;"
					class="d-flex a-center j-center">{{item}}</div>
				</div>
			</div>
			<div class="d-flex" style="margin-bottom: 1.875rem;">
				<div style="white-space: nowrap;" class="left-trial">其它问题：</div>
				<div  style="width: 350px;">
					<div class="right-trial" style="margin-bottom: 1rem;">{{trialInfo.sup_problem}}</div>
					<div class="d-flex a-center flex-wrap" style="width: 100%;box-sizing: border-box;" v-if="trialInfo.problem_img && trialInfo.problem_img.length!=0">
						<div v-for="(item,index) in trialInfo.problem_img" :key="index"
						style="height: 80px;width: 80px;border-radius: 10px;margin-right: 1rem;">
							<img :src="item" style="height: 80px;width: 80px;border-radius: 10px;margin-right: 1rem;" alt="">
						</div>
					</div>
				</div>
			</div>
			<div class="d-flex a-center" style="margin-bottom: 1.875rem;" v-if="trialInfo.status==2">
				<div style="white-space: nowrap;" class="left-trial">拒绝理由：</div>
				<div class="right-trial">{{trialInfo.review_content}}</div>
			</div>
			<div class="d-flex a-center" style="margin-bottom: 1.875rem;" v-if="trialInfo.is_become_customer==1">
				<div style="white-space: nowrap;" class="left-trial">转为客户时间：</div>
				<div class="right-trial">{{trialInfo.become_time}}</div>
			</div>
			<div class="d-flex a-center" style="margin-bottom: 1.875rem;" v-if="trialInfo.end_time!=''">
				<div style="white-space: nowrap;" class="left-trial">试用结束时间：</div>
				<div class="right-trial">{{trialInfo.end_time}}</div>
			</div>
			<div class="d-flex a-center" style="margin-bottom: 1.875rem;" v-if="trialInfo.status!=0">
				<div style="white-space: nowrap;" class="left-trial">审批管理员：</div>
				<div class="right-trial">{{trialInfo.review_user}}</div>
			</div>
			<div style="width: 100%;box-sizing: border-box;margin-top: 100px;" class="">
				<template v-if="trialInfo.status==0">
					<el-button size="mini"
						style="color: #FFFFFF; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;color: #000000;"
						@click="review_try_goods(1)">同意申请</el-button>
					<el-button size="mini"
						style="background: #1E69FF;color: #FFFFFF; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;margin-left: 1rem;"
						@click="review_try_goods(2)">拒绝申请</el-button>
				</template>
				<template v-if="trialInfo.status==1">
					<el-button size="mini"
						style="background: #1E69FF;color: #FFFFFF; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;margin-left: 100px;"
						@click="changeCustomer()">转为客户</el-button>
				</template>
			</div>
		</div>
		<el-dialog
		  title="拒绝申请返回理由"
		  :visible.sync="hzhbShow"
		  width="480px"
		  center
		  :show-close="false"
		  top="15vh">
		  <div style="max-height: 300px;overflow-y: scroll;display: flex;flex-wrap: wrap;
		  box-sizing: border-box;padding: 0 30px;">
			 <textarea maxlength="-1" style="border-radius: 10px;background-color: #EEEEEE;height: 128px;color: #000000;font-size: 14px;padding: 8px;width: 100%;" v-model="review_content"></textarea>
		  </div>
		  <span slot="footer" class="dialog-footer d-flex j-center">
		    <el-button @click="setmyptList()" size="small" >清 空</el-button>
		    <el-button @click="refuse" size="small" type="primary" >确 定</el-button>
		  </span>
		</el-dialog>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				try_id:'',
				trialInfo:{},
				hzhbShow:false,
				review_content:'',
				curid:''
			}
		},
		methods:{
			admin_get_try_goods_sp_info(){
				let param = {
					act:'admin_get_try_goods_sp_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					try_id: this.try_id
				}
				this.$api.admin_get_try_goods_sp_info(param).then((res)=>{
					this.trialInfo=res.data
				})
			},
			setmyptList(){
				this.review_content=''
				this.hzhbShow=false
			},
			refuse(){
				let param = {
					act:'review_try_goods',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					try_ids:this.curid,
					status:2,
					review_content:this.review_content
				}
				this.$api.review_try_goods(param).then((res)=>{
					if(res.code==0){
						this.$message({
							showClose: false,
							message: '拒绝成功',
							type: 'success',
							offset: 350
						})
						this.hzhbShow=false
						this.admin_get_try_goods_sp_info()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
			review_try_goods(status){
				if(status==2){
					this.hzhbShow=true
					let arr=this.try_id.split(',')
					this.curid=arr.join(',')
				}else{
					let arr=this.try_id.split(',')
					let param = {
						act:'review_try_goods',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						try_ids:arr.join(','),
						status:1
					}
					this.$api.review_try_goods(param).then((res)=>{
						if(res.code==0){
							this.$message({
								showClose: false,
								message: '同意成功',
								type: 'success',
								offset: 350
							})
							this.admin_get_try_goods_sp_info()
						}else{
							this.$message({
								showClose: false,
								message: res.msg,
								type: 'error',
								offset: 350
							})
						}
					})
				}
			},
			changeCustomer(){
				let arr=this.try_id.split(',')
				let param = {
					act:'admin_save_become_customer',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					try_ids:arr.join(',')
				}
				this.$api.admin_save_become_customer(param).then((res)=>{
					if(res.code==0){
						this.$message({
							showClose: false,
							message: '转为客户成功',
							type: 'success',
							offset: 350
						})
						this.admin_get_try_goods_sp_info()
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			},
		},
		created() {
			this.try_id = this.$route.query.try_id
			this.admin_get_try_goods_sp_info()
		}
	}
</script>

<style scoped>
	.content-box{
		width: 85rem;
		min-height: 55rem;
		box-sizing: border-box;
		background-color: #FFFFFF;
		border-radius: 10px;
		padding: 2.375rem 0 2.375rem 28rem;
	}
	.left-trial{
		color: #000000;
		font-size: 12px;
		font-weight: 600;
		width: 170px;
	}
	.right-trial{
		color: #888888;
		font-size: 12px;
		font-weight: 600;
	}
</style>